import { useState } from "react";
import '../styles/navbar.css';
import logo from '../assets/logo1jm.png';
import { Link } from "react-router-dom";

function Navbar() {
  const [navActive, setNavActive] = useState(false);

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  return (
    <>
      <nav>
        <div className="logo">
          <Link to="/nosotros">
            <img src={logo} alt="logo" style={{ cursor: 'pointer' }} />
          </Link>
          <h1>JUGUETERIA MAGO</h1>
        </div>
        <ul className={`main-menu ${navActive ? 'active' : ''}`}>
          <li><Link to="/nosotros">Nosotros</Link></li>
          <li><Link to="/catalogo">Lo que tenemos para ti</Link></li>
          <li><Link to="/fundadores">Fundadores</Link></li>
          <li><Link to="/contacto">Contacto y redes</Link></li>
        </ul>
        <div
          className={`hamburger ${navActive ? 'hamburger-active' : ''}`}
          onClick={toggleNav}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => { if(e.key === 'Enter') toggleNav(); }}
          aria-label="Toggle navigation menu"
        >
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </nav>

      <div className={`menubar ${navActive ? 'active' : ''}`}>
        <ul>
          <li><Link to="/nosotros" onClick={() => setNavActive(false)}>Nosotros</Link></li>
          <li><Link to="/catalogo" onClick={() => setNavActive(false)}>Lo que tenemos para ti</Link></li>
          <li><Link to="/fundadores" onClick={() => setNavActive(false)}>Fundadores</Link></li>
          <li><Link to="/contacto" onClick={() => setNavActive(false)}>Contacto y redes</Link></li>
        </ul>
      </div>
    </>
  );
}

export default Navbar;
